import AIGetHelpIcon from 'src/modules/3rd-party-management/assets/images/microchip/black.png';

const ChipIcon = () => (
    <span className="overview-esg-rating__chip" aria-hidden="true">
        <img
            src={AIGetHelpIcon}
            alt=""
            width={16}
            height={16}
        />
    </span>
);

export default ChipIcon;
